// The hotel's clock is the one that counts. A guest asking for a 9 PM cab means 9 PM at
// the hotel, whatever their phone is set to, so times are sent and shown in hotel time
// rather than in the device's timezone.
export const HOTEL_TIMEZONE = "Asia/Kolkata";
export const HOTEL_UTC_OFFSET = "+05:30";

const pad = (value, size = 2) => String(value).padStart(size, "0");

// Keeps the wall clock the guest picked and labels it as hotel time, so 9 PM on the
// picker is stored as 9 PM at the hotel and never shifted by the device's offset.
export function toHotelISO(value) {
    const date = new Date(value);

    return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
        `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` +
        `.${pad(date.getMilliseconds(), 3)}${HOTEL_UTC_OFFSET}`
    );
}

// The API returns instants in UTC; these render them on the hotel's clock.
export function formatHotelTime(value, options = { hour: "2-digit", minute: "2-digit" }) {
    return new Date(value).toLocaleTimeString([], { timeZone: HOTEL_TIMEZONE, ...options });
}

export function formatHotelDate(value, options = { day: "numeric", month: "short" }, locale = "en-GB") {
    return new Date(value).toLocaleDateString(locale, { timeZone: HOTEL_TIMEZONE, ...options });
}

export function formatHotelDateTime(value, options, locale = "en-IN") {
    return new Date(value).toLocaleString(locale, { timeZone: HOTEL_TIMEZONE, ...options });
}
